import { clientAppLog, createCodeSourceName } from '@/app/components/search/logging/clientAppLog.ts';

const PLACEHOLDER = /__[a-zA-Z0-9_-]+?__/;
const reportedKeys = new Set<string>();

type RawPlaceholder = { key: string; locale: string | undefined; text: string; rendered: string };

export const logRawPlaceholder = ({ key, locale, text, rendered }: RawPlaceholder) => {
  const placeholder = rendered.match(PLACEHOLDER)?.[0];
  if (typeof window === 'undefined' || !placeholder || reportedKeys.has(key)) return;

  reportedKeys.add(key);
  clientAppLog({
    level: 'ERROR',
    codeSourceName: createCodeSourceName('RawPlaceholder'),
    logMessage: `Translation shows raw placeholder. key=${key} placeholder=${placeholder} locale=${locale} text=${JSON.stringify(text)}`,
    url: window.location.href,
  });
};
